export const PAGE_BREAKFAST = "PAGE_BREAKFAST";
export const PAGE_LUNCH = "PAGE_LUNCH";
export const PAGE_SNACKS = "PAGE_SNACKS";

export const CITY_PUNE = 'pune';



// WEBPACK FOOTER //
// ./src/utils/constants.js